import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const MatchingPasswords: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const password = control.get('newPassword');
  const confirmPassword = control.get('confirmNewPassword');

  confirmPassword?.setErrors(getMatching(password?.value, confirmPassword?.value));

  return getMatching(password?.value, confirmPassword?.value);
};

function getMatching(password: string, confirmPassword: string) {
  return password === confirmPassword ? null : { notMatched: true };
}

export function MatchingPasswordsWithParams(keys: {
  passwordKey: string;
  confirmPasswordKey: string;
}): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.get(keys.passwordKey);
    const confirmPassword = control.get(keys.confirmPasswordKey);

    confirmPassword?.setErrors(getMatching(password?.value, confirmPassword?.value));

    return getMatching(password?.value, confirmPassword?.value);
  };
}
